<script setup lang='ts'>
import { ref } from 'vue'
import AgroTrade from '@images/AgroTrade.svg?raw'

const drawer = ref(false)
const menuItems = ref([
  { text: 'How it Works', href: '#how-it-works', id: 'how-it-works' },
  { text: 'About', href: '#about', id: 'about' },
  { text: 'News', href: '#news', id: 'news' },
  { text: 'Testimonial', href: '#testimonial', id: 'testimonial' },
  { text: 'FAQ', href: '#faq', id: 'faq' },
  { text: 'SignUp', href: '/register', id: 'register'},
  { text: 'Login', href: '/login', id: 'login'},
])


const postAds = () => {
  // Implement your logic for posting ads here
  window.location.href = 'login'
}

// Smooth scrolling function
const scrollToSection = (hash) => {
  const target = document.querySelector(hash);
  if (target) {
    target.scrollIntoView({ behavior: "smooth" });
  }
}
</script>

<template>
  <VApp>
    <!-- App Bar -->
    <VAppBar scroll-behavior="collapse" app style="height: 70px; padding: 2px !important;">
      <!-- Navigation Icon (visible only on mobile) -->
      <VAppBarNavIcon
        @click="drawer = !drawer"
        class="d-lg-none"
        aria-label="Toggle Navigation"
      />

      <!-- Logo -->
      <VImg
        v-html='AgroTrade'
        cover
        height="50"
        width="50"
        class="ml-6 mt-2"
      />

      <!-- Spacer -->
<!--      <VSpacer />-->

      <!-- Menu Items (visible only on desktop) -->
      <div class="d-none d-lg-flex">
        <VBtn
          v-for="item in menuItems"
          :key="item.text"
          text
          :href="item.href"
          @click.prevent="scrollToSection(item.href)"
        >
          {{ item.text }}
        </VBtn>
      </div>

      <!-- Post Ads Button -->
      <VBtn
        size="large"
        color="warning-darken-2"
        elevation="15"
        variant="flat"
        @click="postAds"
        class="ml-4"
      >
        Post Ads
      </VBtn>
    </VAppBar>

    <!-- Navigation Drawer for Mobile View -->
    <VNavigationDrawer
      v-model="drawer"
      app
      temporary
      class="d-lg-none"
    >
      <VList>
        <VListItem
          v-for="item in menuItems"
          :key="item.text"
          @click="scrollToSection(item.href); drawer = false"
          color="primary"
          :aria-label="`Go to ${item.text}`"
        >
          <VListItemTitle>{{ item.text }}</VListItemTitle>
        </VListItem>
      </VList>
    </VNavigationDrawer>

    <!-- Main Content -->
    <VMain>
      <VContainer class="mt-16"> <!-- Adjusted margin to avoid overlap -->
        <VCol cols="12">
          <div class="landing-page-title text-center">
            <span class="landing-page-body-text-span">Sell</span>,
            <span class="landing-page-body-text-span">Buy</span> and
            <span class="landing-page-body-text-span">Advertise</span> your Agro Products and Services with
            <span class="landing-page-body-text">AgroTrade</span>
          </div>
        </VCol>
        <VCol cols="12" class="mt-6 text-center">
          <span class="text-h5 font-weight-bold"> Are you a business? </span>
          <VBtn
            rounded="xl"
            variant="flat"
            color="info"
            size="large"
            elevation="15"
            prepend-icon="$next"
            :to="'/register'"
          >
            <span> Get Started </span>
          </VBtn>
        </VCol>
      </VContainer>
    </VMain>
  </VApp>
</template>

<style>
.landing-page-title  {
  color: #3E2723;
  font-size: 5.375rem;
  font-weight: 800;
  line-height: 5.75rem;
  font-family: "Microsoft Sans Serif",sans-serif;
  display: block;
  opacity: 2.0;
  margin-top: 3.7rem;
  background-clip: content-box;
}
.landing-page-body-text{
  color: #FF6E40;
  background-clip: content-box;
}
.landing-page-body-text-span {
  color: #3b7d35ff;
  background-clip: content-box;
}
/* Adjust font size for smaller screens */
@media (max-width: 600px) {
  .landing-page-title {
    font-size: 2.5rem;
    line-height: 3.5rem;
    margin-top: 3rem;
  }
}

/* Your custom styles here */
</style>
